import React from 'react';
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {CallBackProps, Step} from "react-joyride";
import {JourneyStyled} from "@dropDesk/presentation/components/journeys/joyride/styled";


export const Journey = (
    {
        steps,
        run,
        continuous,
        handleJoyrideCallback,
        stepIndex
    }: {
        steps: Array<Step>
        run: boolean
        continuous: boolean
        handleJoyrideCallback: (data: CallBackProps) => void
        stepIndex?: number
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <JourneyStyled
            color={colors.text}
            callback={handleJoyrideCallback}
            continuous={continuous}
            run={run}
            scrollToFirstStep={true}
            showProgress={true}
            showSkipButton={true}
            steps={steps}
            disableOverlayClose={true}
            disableCloseOnEsc={true}
            hideCloseButton={true}
            stepIndex={stepIndex}
            locale={{
                back: 'Voltar',
                close: 'Fechar',
                last: 'Último',
                next: 'Próximo',
                nextLabelWithProgress: 'Próximo (Etapa {step} de {steps})',
                open: 'Abrir a caixa de diálogo',
                skip: 'Pular'
            }}
            styles={{
                options: {
                    arrowColor: colors.onBackground,
                    backgroundColor: colors.onBackground,
                    overlayColor: 'rgba(0, 0, 0, 0.4)',
                    primaryColor: colors.accent,
                    textColor: colors.text,
                    width: 400,
                    zIndex: 99999,
                },
                overlay: {
                    zIndex: 99999,
                }
            }}
        />
    );

};
